// import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'

export default {
  restaurants: state => state.restaurants,
  promotions: state => state.promotions
}



// WEBPACK FOOTER //
// ./src/store/modules/content/getters.js